module.exports = __webpack_public_path__ + "static/img/more-2.b123958d.png";